import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getProviderClientDetailsModel = createAsyncThunk("provdier/get-all-details", async (id, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/client/get-all-details/${id}`, {
            // headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data.client);
    return res.data.client;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch client details");
  }
});

const providerClientDetailsModelSlice = createSlice({
  name: "providerClientDetailsModel",
  initialState: {
    providerClientDetailsModelData: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getProviderClientDetailsModel.fulfilled, (state, action) => {
      state.providerClientDetailsModelData = action.payload;
    });
  },
});


export default providerClientDetailsModelSlice.reducer;